export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogTable.vue?vue&type=template&id=40b40be4&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/Tables/CatalogTable.vue?vue&type=template&id=40b40be4&scoped=true
// module id = 1465
// module chunks = 31